// extracted by mini-css-extract-plugin
module.exports = {"dpu-calculator":"DPUCalculator_dpu-calculator__NAevu"};